@if (isLoading()) {
  <div class="fixed inset-0 z-50 flex items-center justify-center bg-black/20 backdrop-blur-[1px]">
    <div class="flex flex-col items-center gap-3 bg-white rounded-2xl p-6 shadow-lg">
      <div
        class="h-10 w-10 animate-spin rounded-full border-[3px] border-slate-200 border-t-accent-600"
        role="status"
      >
        <span class="sr-only">Cargando...</span>
      </div>
      <span class="text-sm font-medium text-slate-600">Cargando...</span>
    </div>
  </div>
}
